import { render, staticRenderFns } from "./CustomVideo.vue?vue&type=template&id=7317afa0&scoped=true&"
import script from "./CustomVideo.vue?vue&type=script&lang=js&"
export * from "./CustomVideo.vue?vue&type=script&lang=js&"
import style0 from "./CustomVideo.vue?vue&type=style&index=0&id=7317afa0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7317afa0",
  null
  
)

export default component.exports